<template>
  <v-navigation-drawer
    app
    clipped
    style="border-right: 1px solid gray"
    width="300"
  >
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-avatar size="60%">
            <img
              src="../assets/emptyuserphoto.png"
              alt="User Photo"
              :style="avatarStyle"
            />
          </v-list-item-avatar>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="ma-0 pa-0">
        <v-container fluid>
          <v-text-field
            :disabled="online"
            v-model="tempUsername"
            label="Логин"
            outlined
            required
            hide-details
            class="pb-2"
          ></v-text-field>

          <v-text-field
            :disabled="online"
            v-model="tempPassword"
            label="Пароль"
            type="password"
            outlined
            required
            hide-details
            class="pb-2"
          />

          <v-container fluid>
            <v-row justify="center">
              <v-btn
                :disabled="disabledLoginButton || online"
                class="ma-2 pa-6"
                color="success"
                @click="onLogin"
                >Вход</v-btn
              >
              <v-btn
                :disabled="!online"
                class="ma-2 pa-6"
                color="warning"
                @click="onLogoff"
                >Выход</v-btn
              >
            </v-row>
          </v-container>

          <v-divider class="my-4"></v-divider>
<!-- online:{{online}} -->
<!-- isEnterMode:{{isEnterMode}} -->

          <v-container fluid v-if="online">
            <v-row justify="center">
              <v-btn
                :disabled="isEnterMode"
                class="ma-2 pa-6"
                color="info"
                @click="SetEnterMode(true)"
                >Ввод заявок</v-btn
              >
              <v-btn
                :disabled="!isEnterMode"
                class="ma-2 pa-6"
                color="info"
                @click="SetEnterMode(false)"
                >Поиск заявок</v-btn
              >
            </v-row>
          </v-container>

<!-- {{isEnterMode}} -->
<!-- {{fflag==null?'null':fflag}} -->
<!-- {{isIndividual==null?'null':isIndividual}} -->

          <!-- <v-flex xs12 class="pt-4" v-if="online && isEnterMode"> -->
          <v-flex xs12 class="pt-4" v-if="online">
            <template v-if="isEnterMode">
              <v-select
                label="Шаблон"
                :items="patterns"
                :value="patternIndex"
                item-text="R_NAME"
                item-value="R_ID_TEMPL"
                outlined
                ref="pattern"
                @input="changePattern"
              ></v-select>
            </template>

            <template v-else>

            <!-- <template v-slot:append> -->

              <div class="pb-6" v-if="isIndividual===true">
                <v-text-field
                  v-model="cardId"
                  label="Номер заявки"
                  outlined
                  required
                  @keypress="onlyDigit"
                  hide-details
                ></v-text-field>

                <v-container fluid>
                  <v-row justify="center">
                    <v-btn
                      :disabled="!online || !cardId"
                      class="ma-2 pa-6"
                      color="success"
                      @click="onCheckCard"
                      >Проверить статус</v-btn
                    >
                  </v-row>
                </v-container>
              </div>

            </template>

            <template>
              <v-dialog v-model="checkCardDialog" persistent max-width="400px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Проверка заявки</span>
                  </v-card-title>
                  <div id="printArea">
                    <v-card-text>Номер заявки: {{ cardId }} </v-card-text>
                    <v-card-text>Статус заявки : {{ checkCardStatus }} </v-card-text>
                    <v-card-text v-if="checkCardQR">
                      <div align="center">
                        <img
                          :src="checkCardQR"
                          class="mx-auto"
                          height="200"
                          width="200"
                        />
                      </div>
                    </v-card-text>
                  </div>

                  <v-card-text>
                    <v-card-actions>
                      <v-btn
                        :disabled="!checkCardQR"
                        color="blue darken-1"
                        text
                        @click="printQR"
                        >Распечатать QR-код</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="
                          checkCardDialog = false;
                          checkCardQR = null;
                        "
                        >Закрыть</v-btn
                      >
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-dialog>
            <!-- </template> -->

            </template>
          </v-flex>
        </v-container>
      </v-list-item>

      <!-- <v-divider></v-divider> -->
    </v-list>
    
  </v-navigation-drawer>
</template>

<script>
var qr = require("qr-image");
import { Printd } from "printd";

import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "AppNavigation",

  data: () => ({
    tempUsername: "",
    tempPassword: "",

    cardId: null,

    checkCardDialog: false,
    checkCardStatus: null,
    checkCardQR: null,

    AlertLogin: false,
  }),

  computed: {
    disabledLoginButton: function () {
      if (this) {
        // if (this.tempUsername && this.tempPassword && this.selectedOrg) {
        if (this.tempUsername) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    avatarStyle: function () {
      if (this.online) return "border: 3px solid green";
      else if (this.AlertLogin) return "border: 3px solid red";
      else return "border: 3px solid gray";
    },

    ...mapGetters({
      noCamera: "account/noCamera",
      username: "account/username",
      password: "account/password",
      userId: "account/userId",
      orgId: "account/orgId",
      online: "account/online",
      fflag: "account/fflag",
      isEnterMode: "account/isEnterMode",     // true - ввод заявок, false - просмотр
      isIndividual: "account/isIndividual",   // true - индивидуальный пользователь, false - групповой пользователь

      patterns: "patterns/list",
      patternIndex: "patterns/selectedIndex",
      pattern: "patterns/selected",
    }),
  },

  async beforeMount() {
    this.tempUsername = this.username;
  },

  methods: {
    ...mapActions("account", [
      "Login",
      "Logoff",
      "StartLoading",
      "StopLoading",
      "SetOnline",
      "CheckCard",
      "SetEnterMode",
    ]),
    ...mapActions({
      GetPatterns: "patterns/GetList",
      ClearPatterns: "patterns/Clear",
      SetPattern: "patterns/SetSelected",
    }),

    onCancel() {
      console.log("User cancelled the loader.");
    },

    async onLogin() {
      this.StartLoading();
      this.Login({ username: this.tempUsername, password: this.tempPassword })
        .then((loginRes) => {
          if (loginRes.result) {
            this.SetOnline(true);
            this.AlertLogin = false;
            this.GetPatterns(this.userId).then((getPatternsRes) => {
              if (!getPatternsRes.result) {
                this.$fire({
                  text: getPatternsRes.error,
                  type: "error",
                });
              }
              else{
                // Установим фокус на список шаблонов
                // this.$refs.pattern.focus();  // MV
                // Если шаблон не пустой, то сделаем активным первый шаблон в списке
                if (this.patterns.length){
                  this.changePattern(this.patterns[0].R_ID_TEMPL);
                }
              }
            });
          } else {
            this.ClearPatterns();
            this.AlertLogin = true;
            this.$fire({
              text: loginRes.error,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.ClearPatterns();
          this.SetOnline(false);
          this.AlertLogin = true;
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
        .finally(() => {
          this.StopLoading();
        });
    },

    async onLogoff() {
      this.StartLoading();
      this.Logoff()
        .then((logoffRes) => {
          if (logoffRes.result) {
            this.tempPassword = "";
            this.ClearPatterns();
            this.AlertLogin = false;
          } else {
            this.AlertLogin = true;
            this.$fire({
              text: logoffRes.error,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.AlertLogin = true;
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
        .finally(() => {
          this.StopLoading();
        });

      document.title = 'Аккредитация';
    },

    async onCheckCard() {
      this.checkCardDialog = true;
      this.checkCardStatus = "идёт проверка...";
      this.checkCardQR = null;
      this.CheckCard(this.cardId)
        .then((checkCardRes) => {
          if (checkCardRes.result) {
            this.checkCardStatus = checkCardRes.result[0].R_STATUS_NAME;

            if (checkCardRes.result[0].R_QR) {
              const u8 = qr.imageSync(checkCardRes.result[0].R_QR, {
                type: "png",
              });
              this.checkCardQR = `data:image/png;base64, ${btoa(
                String.fromCharCode.apply(null, u8)
              )}`;
            }
          } else {
            this.checkCardDialog = false;
            this.$fire({
              text: checkCardRes.error,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.checkCardDialog = false;
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
    },

    printQR() {
      const d = new Printd();
      d.print(document.getElementById("printArea"));
    },

    changePattern(value) {
      this.StartLoading();
      this.SetPattern(value)
        .then((SetPatternRes) => {
          // console.log("SetPatternRes", SetPatternRes);
          if (SetPatternRes.error) {
            this.$fire({
              text: SetPatternRes.error,
              type: "error",
            });
          }
          else{
            if (SetPatternRes.result && SetPatternRes.result.length > 0){
              const event = SetPatternRes.result[0].R_EVENT;
              const org = SetPatternRes.result[0].R_ORG;

              document.title = (event ? event + ' - ' : '') + 'Аккредитация' + (org ? ' - ' + org : '');
            }
          }
        })
        .catch((err) => {
          console.log("SetPatternRes", err);
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
        .finally(() => {
          this.StopLoading();
        });
    },

    onlyDigit($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      } else if ($event.target.value == "0") {
        $event.target.value = "";
      }
    },
  },
};
</script>
